import { render, staticRenderFns } from "./QuestionSearchResults.vue?vue&type=template&id=f0b7e2fe&"
import script from "./QuestionSearchResults.vue?vue&type=script&lang=js&"
export * from "./QuestionSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports